__turbopack_context__.v({
  "body": "EndState-module-scss-module__-qfTMG__body",
  "headline": "EndState-module-scss-module__-qfTMG__headline",
  "icon": "EndState-module-scss-module__-qfTMG__icon",
  "resetButton": "EndState-module-scss-module__-qfTMG__resetButton",
  "root": "EndState-module-scss-module__-qfTMG__root",
  "social": "EndState-module-scss-module__-qfTMG__social",
});
